import { Autocomplete, TextField, ListItem, ListItemText } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useListCompaniesQuery } from "services/adminService";

const PlaceholderInput = ({ label }) => (
  <TextField label={label} variant={"outlined"} size={"small"} disabled />
);

const CompanySelector = ({ companyId }) => {
  const navigate = useNavigate();
  const { data, isLoading, isError } = useListCompaniesQuery();
  const companyList = data?.map((c) => c.id)?.sort() ?? [];
  const globalCompanyId = "global";

  if (isLoading) {
    return <PlaceholderInput label={"Loading…"} />;
  } else if (isError) {
    return <PlaceholderInput label={"Failed to load companies list"} />;
  }

  return (
    <Autocomplete
      options={companyList}
      getOptionKey={(companyId) => companyId}
      getOptionLabel={(companyId) => companyId}
      value={companyId === globalCompanyId ? null : companyId}
      renderInput={(params) => (
        <TextField {...params} variant={"outlined"} label={"Select Company"} />
      )}
      onChange={(_, value) => navigate(`/admin/${value ?? globalCompanyId}`)}
      renderOption={(props, option) => (
        <ListItem {...props}>
          <ListItemText sx={{ whiteSpace: "nowrap" }}>{option}</ListItemText>
        </ListItem>
      )}
      size={"small"}
      sx={{ minWidth: "20rem" }}
    />
  );
};

export default CompanySelector;
